export default {
  methods: {
    isAddressAnGroup (address) {
      return !!address?.addresses || false
    }
  }
}
